import Vue from 'vue'
import VueRouter from 'vue-router'
import Declaration from '../views/Declaration.vue'
import Summary from '../views/Summary.vue'
import Intro from '../views/Intro.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Intro',
    component: Intro
  },
  {
    path: '/Declaration',
    name: 'Declaration',
    component: Declaration
  },
  {
    path: '/Summary',
    name: 'Summary',
    component: Summary
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
